var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbotSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_22400_59244)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.448 18.8937C25.6139 18.8106 25.7534 18.6829 25.8509 18.525C25.9484 18.3672 26 18.1853 26 17.9997C26 17.8142 25.9484 17.6323 25.8509 17.4744C25.7534 17.3165 25.6139 17.1888 25.448 17.1057L11.4475 10.1057C11.2739 10.0188 11.0788 9.98439 10.886 10.0065C10.6931 10.0287 10.5109 10.1065 10.3615 10.2304C10.2121 10.3543 10.102 10.5191 10.0447 10.7045C9.9873 10.8899 9.98515 11.0881 10.0385 11.2747L11.4675 16.2747C11.5273 16.4837 11.6535 16.6675 11.8271 16.7983C12.0007 16.9291 12.2122 16.9998 12.4296 16.9997L17.0007 16.9997C17.266 16.9997 17.5203 17.1051 17.7079 17.2926C17.8954 17.4801 18.0008 17.7345 18.0008 17.9997C18.0008 18.2649 17.8954 18.5193 17.7079 18.7068C17.5203 18.8944 17.266 18.9997 17.0007 18.9997L12.4296 18.9997C12.2122 18.9996 12.0007 19.0703 11.8271 19.2011C11.6535 19.3319 11.5273 19.5157 11.4675 19.7247L10.0395 24.7247C9.98604 24.9113 9.98806 25.1094 10.0453 25.2948C10.1025 25.4803 10.2125 25.6451 10.3617 25.7691C10.511 25.8932 10.6932 25.9711 10.886 25.9934C11.0788 26.0157 11.2739 25.9814 11.4475 25.8947L25.448 18.8937Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22400_59244",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#228B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228B22",
    stopOpacity: 0.73
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotSendIcon);
export default __webpack_public_path__ + "static/media/chatbot-send-icon.55dd03af.svg";
export { ForwardRef as ReactComponent };